<template>
    <ac-confirmation-modal :title="'Verify Group Offering Update'"
                           :size-class="'modal-md'"
                           :accept-button="'Terminate Existing Plans'"
                           ref="modal">
        <template>
            <div class="row">
                <div class="col-md-12">
                    <div class="alert alert-warning">
                        <p>The following employees are associated to a non-private plan</p>
                        <p>
                            This means that instead of selecting the private plans from this offering they
                            selected a separate plan offered by the providers.
                        </p>
                        <p v-for="ac in affectedConsumers">
                            {{ac.firstName}}&nbsp;{{ac.lastName}} - {{ac.planName}}
                            Plan effective date: {{ac.planEffectiveDate | shortDate}}
                        </p>
                        <p>By clicking 'Terminate Existing Plans' below, the employees' plans will be terminated at the end of the month.</p>
                    </div>
                </div>
            </div>
        </template>
    </ac-confirmation-modal>
</template>

<script>
    import {api} from "../../../../global/framework/api.js";

    export default {
        name: "PlanPoolUpdateVerificationModal",
        props: {consultantId: {type: [Number], required: true}},
        data() {
            return {
                affectedConsumers: []
            }
        },
        methods: {
            async showModal(planPoolId) {
                this.affectedConsumers = [];
                let data = await api.getDataWithTwoIds('MediatorPlan', this.consultantId, `GetConsumersInPlanPoolWithoutPrivatePlan`, planPoolId);
                if (Array.isArray(data)) {
                    if (data.length > 0) {
                        this.affectedConsumers = data;
                        let result = await this.$refs.modal.showModal();
                        return result;
                    }
                    return true;
                }
                return false;

            }
        }
    }
</script>

<style scoped>

</style>